import { useEffect, useState } from "react";
import axios from "src/config/axios";

const useStats = (category, from, to) => {
  const [statsResponse, setStatsResponse] = useState(null);
  const requestKey = `${category}:${from}:${to}`;
  const stats = statsResponse?.key === requestKey ? statsResponse.data : null;

  useEffect(() => {
    let active = true;

    axios
      .get(`/api/v1/stats/${category}.json`, {
        params: { from, to, interval: "auto" },
      })
      .then((response) => {
        if (active) {
          setStatsResponse({ key: requestKey, data: response.data.table });
        }
      })
      .catch((error) => console.log(error));

    return () => {
      active = false;
    };
  }, [category, from, to, requestKey]);

  return stats;
};

export default useStats;
